import { useState } from 'react'
import { useSelector, shallowEqual } from 'react-redux'
import MultiClamp from 'react-multi-clamp'

import { useResize } from 'reactUtils/hooks/use-resize'

import { default as QuantityButton } from 'checkout/containers/ProductQuantity'
import { Content } from 'checkout/components/CrossServices/Installation'

import PriceInfo from './PriceInfo'
import ProductError from './ProductError'
import * as S from './styled'
import productPropTypes from '../../prop-types/product'

const Product = ({
  brand,
  categoryTree,
  errors,
  id,
  thumbUrl,
  productUrl,
  name,
  shippingType,
  shopName,
  storeId,
  skuId,
  packaging,
  packagingCount,
  packagingUnitLabels,
  productId,
  translatedUnit,
  quantity,
  price,
  updateProduct,
  onRemove,
  services,
  regionId
}) => {
  const availableServices = useSelector(
    state => state.crossServices.get.payload.filter(service => service.productId === productId),
    shallowEqual
  )

  const [customError, setCustomError] = useState([])

  const [isMobile] = useResize()

  const onError = data => {
    if (data.errors) {
      setCustomError({
        stock: data.errors?.[0]
      })
    }
  }

  const onSuccess = ({ currentPackaging, productMaxStock }) => {
    if (currentPackaging < productMaxStock && productMaxStock !== Infinity) {
      setCustomError([])
    }
  }

  const checkRelatedServices = () => {
    if (!availableServices) return

    const addedServices = services && services.filter(service => service.relatedProduct.productId === productId)

    const product = {
      productName: name,
      relatedId: id,
      productQuantity: quantity,
      skuId
    }

    if (addedServices?.length > 0) {
      const addedService = addedServices[0]

      return {
        ...addedService,
        ...product,
        isAvailable: true,
        isAdded: true,
        price: {
          ...addedService.price
        }
      }
    }

    if (availableServices.length > 0) {
      const availableService = availableServices[0].services[0]

      return {
        ...availableService,
        ...product,
        serviceId: availableService.id,
        isAvailable: true,
        price: {
          total: availableService.price.to * quantity,
          ...availableService.price
        }
      }
    }
  }

  const getRelatedServices = checkRelatedServices()

  return (
    <S.WrapperColumn data-cy="cart-product">
      <S.InfoWrapper>
        <S.AnchorImage href={productUrl}>
          <S.Image src={thumbUrl} />
        </S.AnchorImage>
        <S.Column>
          <S.BasicInfoWrapper>
            <S.Name href={productUrl} title={name}>
              <MultiClamp ellipsis="..." clamp={isMobile ? 2 : 1} itemProp="name">
                {name}
              </MultiClamp>
            </S.Name>
            <S.SmallInfo>
              Vendido e entregue por <strong>{shopName}</strong>
            </S.SmallInfo>
          </S.BasicInfoWrapper>
          <S.PriceInfoWrapper>
            <QuantityButton
              brand={brand}
              name={name}
              categoryTree={categoryTree}
              id={id}
              productId={productId}
              regionId={regionId}
              type={shippingType}
              shopName={shopName}
              quantity={quantity}
              packaging={packaging}
              packagingCount={packagingCount}
              skuId={skuId}
              storeId={storeId}
              price={price}
              updateProduct={updateProduct}
              onSuccess={({ currentPackaging, productMaxStock }) =>
                onSuccess({ currentPackaging, productMaxStock })
              }
              onError={onError}
              fromCart
            />
            <PriceInfo
              packaging={packaging}
              packagingCount={packagingCount}
              packagingUnitLabels={packagingUnitLabels}
              translatedUnit={translatedUnit}
              quantity={quantity}
              price={price}
            />
          </S.PriceInfoWrapper>
        </S.Column>
        <S.RemoveButton
          onClick={() => onRemove({
            brand,
            categoryTree,
            id,
            productId,
            name,
            price,
            type: shippingType,
            quantity,
            shopName,
            services,
            regionId
          })}
        >
          <i className="glyph glyph-x" />
        </S.RemoveButton>
      </S.InfoWrapper>
      { (errors || customError) && <ProductError errors={{ ...errors, ...customError }} /> }
      {
        checkRelatedServices() &&
          <Content {...getRelatedServices} regionId={regionId} />
      }
    </S.WrapperColumn>
  )
}
Product.propTypes = { ...productPropTypes }

export default Product
